import styled from 'styled-components';
export const PrivacyPolicyStyled = styled.div`
  padding-left: 40px;
  padding-right: 40px;
  background-color: #ffffff;
  .header-top {
    height: 60px;
  }
  .header-group {
    padding: 10px 32px 10px 32px;
    background-color: #ffffff;
  }
  .header-tiltle {
    display: flex;
    justify-content: center;
    font-size: 26px;
    color: #000000;
  }

  .font-weight {
    font-weight: bold;
  }

  .form-group {
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
  }

  .form-group-tiltle {
    border-bottom: 2px solid red;
    padding: 5px 10px 5px 10px;
    font-weight: bold;
    font-size: 22px;
  }
  .form-col {
    padding: 5px 5px 5px 5px;
  }

  .form-col-left {
    display: flex;
    padding: 5px 5px 0px 5px;
    width: 2%;
  }

  .form-col-right {
    padding: 5px 5px 0px 5px;
    width: 98%;
  }

  .no-font {
    font-size: 22px;
  }

  .text-font {
    font-size: 20px;
  }

  .btn-back {
    display: flex;
    align-items: center;
    padding-left: 0;
    padding-right: 0;

    span {
      line-height: 24px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 154px;
      font-size: 20px;
    }
  }
  span {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 154px;
  }
`;
